import React, { useState, useEffect } from 'react'
import { useDispatch } from "react-redux"
import { useHistory , useLocation} from "react-router-dom";
import { Get, getUserData } from "../actions";
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useCookies} from 'react-cookie'
import {
 Grid
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import authService from '../utils/authUtils';
import { SET_USER_DATA } from '../constants/types';
import { Get_CloseService_URL } from '../constants/apiUrls';
import { getTranslation } from '../heplers/translationHelper';
import CloseServiceModal from '../views/Reservations/components/closeServiceModal';


const Auth = (props) => {
/*const Auth = ({setAuth,userLoggedOut,onGetToken,onRefresh,children}) => {

  useEffect(()=>{
    setCookie("app-auth",setAuth)
  },[setAuth])

  
  useEffect(()=>{
    removeCookie("app-auth")
  },[userLoggedOut])
  const [cookies, setCookie, removeCookie] = useCookies(['app-auth']);
  */
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(true)
  const [isModelOpen, setIsModelOpen] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
    },
  }));
  const classes = useStyles();

const initAuth = async () => {
    if (authService.isAuthenticated() || authService.isRefreshAuthenticated()) {
        dispatch(
            getUserData(
                (resp) => {
                    console.log("User Data:", resp.data);
                    dispatch({ type: SET_USER_DATA, payload: resp.data });

                    let userRoles = resp.data?.roles;
                    if (!Array.isArray(userRoles) || userRoles.length === 0) {
                        console.warn("No roles found for user, defaulting to Guest");
                        userRoles = ["Guest"];
                    }

                    const userRole = userRoles[0]; 
                    console.log("User Role:", userRole);

                    history.replace({
                        pathname: history.location.pathname,
                        search: ``,
                    });
                },
                (error) => {
                    enqueueSnackbar(error.data, { variant: "error" });
                    history.push("/login");
                }
            )
        );
    } else {
        history.push("/login");
    }
};

  
  

  useEffect(() => {
    initAuth();
    setLoading(false);
  }, [])
  if (loading)
    return <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justify="center"
      style={{ minHeight: '100vh' }}
    >
      <CircularProgress />
    </Grid>
  return <> {props.children}
  {/* <CloseServiceModal  openDialog={isModelOpen} handleClose={()=>setIsModelOpen(false)} serciveclosedBy={"Yesterday"} /> */}
  </>
}

export default Auth
